import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import './styles.css';


var styles = {
    "term": "DescriptionListElement-module_term__CGIAN",
    "description": "DescriptionListElement-module_description__pSKkG"
};

const DescriptionListElement = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, term, children }, ref)=>{
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx("dt", {
                ref: ref,
                id: id,
                className: `${styles.term} ${className}`.trim(),
                lang: lang,
                "data-testid": dataTestId,
                children: term
            }),
            /*#__PURE__*/ jsx("dd", {
                className: styles.description,
                children: children
            })
        ]
    });
});
DescriptionListElement.displayName = 'DescriptionListElement';

export { DescriptionListElement };
